import './VintageBackground.css';

export default function VintageBackground() {
  return (
    <div className="vintage-bg">
      <div className="vintage-pattern"></div>
      <div className="paper-texture"></div>
      <div className="vintage-elements">
        <div className="vintage-divider"></div>
        <div className="vintage-divider"></div>
        <div className="vintage-divider"></div>
      </div>
    </div>
  );
}